import React, { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { removePrefixPhone } from '../../../utils/addPrefixPhone';
import styles from './SettingsForm.module.css';
import useSettings from './useSettings';

const containerStyle = {
  top: 50,
  left: 20,
  bottom: 20,
  right: 20
};

const SettingsForm = () => {
  const [data, setData] = useState({
    email: '',
    name: '',
    phone: '',
    brand: '',
    logo: ''
  });

  const { changeSettings } = useSettings();

  const { name } = useSelector((state) => state.user.user);
  const { financeEmail, financePhone, name: brand, logoURL } = useSelector((state) => state.user.publisher);

  useEffect(() => {
    setData({
      email: financeEmail,
      name,
      phone: removePrefixPhone(financePhone),
      brand,
      logo: logoURL
    });
  }, [name, financeEmail, financePhone, brand, logoURL]);

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    changeSettings(data);
  };

  return (
    <>
      <form onSubmit={handleSubmit} id={styles['settings-form']}>
        <div>
          <label className={styles.label}>Name</label>
          <input
            required
            type="text"
            name="name"
            onChange={handleChange}
            value={data.name}
            placeholder="Full Name"
            className={styles.input}
          />
          <label className={styles.label}>Email</label>
          <input
            required
            type="email"
            name="email"
            onChange={handleChange}
            value={data.email}
            placeholder="Email Address"
            className={styles.input}
          />
          <label className={styles.label}>Phone</label>
          <input
            required
            type="tel"
            name="phone"
            onChange={handleChange}
            value={data.phone}
            placeholder="Phone Number"
            pattern="[0-9]{10}"
            className={styles.input}
          />
          <label className={styles.label}>Brand</label>
          <input
            required
            type="text"
            name="brand"
            onChange={handleChange}
            value={data.brand}
            placeholder="Brand Name"
            className={styles.input}
          />
          <label className={styles.label}>Logo URL</label>
          <input
            required
            type="url"
            name="logo"
            onChange={handleChange}
            value={data.logo}
            placeholder="Enter Logo URL"
            // pattern="^(http|https)://*"
            className={styles.input}
          />
        </div>
        <input
          type="submit"
          value="Save Settings"
          id={styles.submit}
          disabled={data.email === '' || data.brand === '' || data.phone === '' || data.logo === '' || data.name === ''}
        />
      </form>
      <Toaster containerStyle={containerStyle} />
    </>
  );
};

export default SettingsForm;
